import { AppState, Auth0Provider, useAuth0 } from '@auth0/auth0-react'
import { setUser } from '@sentry/react'
import { PropsWithChildren, useCallback, useEffect } from 'react'
import { useNavigate } from 'react-router-dom'

const SetSentryUser = () => {
  const { user } = useAuth0()
  useEffect(() => {
    setUser(user ? { email: user.email, id: user.sub, username: user.name } : null)
  }, [user])
  return <></>
}

export const AuthProvider = ({ children }: PropsWithChildren) => {
  const navigate = useNavigate()
  const onRedirectCallback = useCallback(
    (appState: AppState | undefined) => {
      navigate(appState?.returnTo ?? window.location.pathname, { replace: true })
    },
    [navigate]
  )

  return (
    <Auth0Provider
      cacheLocation="localstorage"
      domain={import.meta.env.VITE_AUTH0_DOMAIN ?? ''}
      clientId={import.meta.env.VITE_AUTH0_CLIENT_ID ?? ''}
      authorizationParams={{
        audience: import.meta.env.VITE_AUTH0_AUDIENCE,
        redirect_uri: window.location.origin,
        scope: 'openid profile email',
      }}
      onRedirectCallback={onRedirectCallback}
    >
      <SetSentryUser />
      {children}
    </Auth0Provider>
  )
}
